export const GET_GROUP_INFO_REQ = 'GET_GROUP_INFO_REQ';
export const GET_GROUP_INFO_SUCCESS = 'GET_GROUP_INFO_SUCCESS';
export const GET_GROUP_INFO_FAIL = 'GET_GROUP_INFO_FAIL';

export const GET_MEMBER_INFO_REQ = 'GET_MEMBER_INFO_REQ';
export const GET_MEMBER_INFO_SUCCESS = 'GET_MEMBER_INFO_SUCCESS';
export const GET_MEMBER_INFO_FAIL = 'GET_MEMBER_INFO_FAIL';

export const ARCHIVE_MEMBER_INFO_SUCCESS = 'ARCHIVE_MEMBER_INFO_SUCCESS';
export const ARCHIVE_MEMBER_INFO_FAIL = 'ARCHIVE_MEMBER_INFO_FAIL';
